const STORAGE_KEY = 'c4_auth_token';
export const EXPLICIT_LOGOUT_KEY = 'c4_explicit_logout';

export const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setAuthToken = (token: string | null) => {
  try {
    if (token) {
      localStorage.setItem(STORAGE_KEY, token);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore
  }
};

export const setExplicitLogout = (value: boolean) => {
  try {
    if (value) {
      localStorage.setItem(EXPLICIT_LOGOUT_KEY, '1');
    } else {
      localStorage.removeItem(EXPLICIT_LOGOUT_KEY);
    }
  } catch {
    // ignore
  }
};

export const hasExplicitLogout = (): boolean => {
  try {
    return localStorage.getItem(EXPLICIT_LOGOUT_KEY) === '1';
  } catch {
    return false;
  }
};
